import Vue from 'vue'
import moment from 'moment'
import {ROLES as roles} from '~/api/variables.js';
Vue.filter('if_null',function(value){
  if(!value && value!==0) return 'N/A';
  value = value.toString();
  return value;
});
Vue.filter('sexe',function(value){
  if(!value) return 'Indéfini';
  value = value.toString();
  return  value ==='F' ? 'Femme' : 'Homme';
});
Vue.filter('sensation',function(value){
  if(!value) return 'N/A';
  value = value.toString();
  return  value ==='M' ? 'Mental' : 'Phisique';
});
Vue.filter('role',function(value){
  if(!value) return 'N/A';
  value = value.toString();
  return  roles[value] ? roles[value].label : value;
});
Vue.filter('reduction',function(value){
  if(!value) return 'N/A';
  value = value.toString();
  return  value === 'unit' ? '€' : '%';
});
Vue.filter('agenda',function(value){
  if(!value) return 'N/A';
  return  (value.nom).charAt(0).toUpperCase() + '.' +(value.prenom).charAt(0).toUpperCase() + (value.prenom).toLowerCase().slice(1)
});
Vue.filter('age',function(value){
  if(!value) return 'N/A';
  const timeDiff = Math.abs(Date.now() - new Date(value).getTime());
  return  Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25) + ' ans';
});
Vue.filter('in_euro',function(value){
  if(!value && value!==0) return 'N/A';
  value = value.toString();
  return  value + '€';
});
Vue.filter('in_minutes',function(value){
  if(!value) return 'N/A';
  let feedback = '';
  if (value > 0) {
    let days = Math.floor((Math.floor(value / 60)) / 24);
    let hours = Math.floor(value / 60) - (days * 24);
    let mins = value - (days * 24 * 60) - (hours * 60);
    if (days > 0) feedback += days + ' jours ';
    if (hours > 0) feedback += hours + ' h ';
    if (mins > 0) feedback += mins + ' min ';
  }
  if (feedback == '') {
    feedback = '00 min'
  }
  return feedback;
});
Vue.filter('truncate',function(value,param){
  if(!param) param = 13;
  if(!value) return 'N/A';
  return value.length > param ? value.substring(0, param) + "..." : value;
});

Vue.filter('date',function(value){
  if(!value) return 'N/A';
  const date = new Date(value);
  return date.toLocaleDateString();
});
Vue.filter('dateTime',function(value, separator = ' '){
  if(!value) return 'N/A';
  return moment(value).format(`DD-MM-YYYY${separator}HH:mm`);
});

Vue.filter('numberExact',function(value){
  return value > 0? '+' + value : '-' + value;
});
